var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkthemeCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#222734"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2538_101977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2751 51.8503C29.6867 51.8845 29.108 51.6889 28.6611 51.3047C27.7796 50.418 27.7796 48.986 28.6611 48.0993L47.9613 28.799C48.8781 27.9411 50.3166 27.9888 51.1745 28.9056C51.9502 29.7346 51.9954 31.0088 51.2803 31.8907L31.8663 51.3047C31.4252 51.6833 30.8558 51.8786 30.2751 51.8503Z",
    fill: "#95A4C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5516 51.8503C48.9552 51.8478 48.3837 51.611 47.9602 51.1911L28.6599 31.8907C27.8433 30.9371 27.9543 29.502 28.9079 28.6853C29.759 27.9565 31.0142 27.9565 31.8653 28.6853L51.2792 47.9856C52.1958 48.8437 52.2432 50.2823 51.3851 51.1989C51.3509 51.2353 51.3157 51.2706 51.2792 51.3047C50.8039 51.7181 50.1782 51.9157 49.5516 51.8503Z",
    fill: "#95A4C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2538_101977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(28 28)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkthemeCancel);
export default __webpack_public_path__ + "static/media/darkthemeCancel.2c87618d58addf1d65ebc0b0258ab046.svg";
export { ForwardRef as ReactComponent };